/**
 *
 * @/services/endpoints/scales.js
 *
 */

//
// IMPORTS
//

import store from '@/store'

import { httpGet, httpPost, httpPatch } from '@/services/api/http'
import { getUserID, getUserUID } from '@/services/endpoints/session'
import { version, PARTNER } from '@/constants'
import { isProtectedPath } from '@/functions/undo'

// Descontinuar logo
import { fbFullUpdate } from '@/services/firebase'

//
//
//

// --- GESTÃO DA ESCALA

// Criar escala
export const apiCreateScale = (groupID, fields) => httpPost({ route: `api/v1/groups/${groupID}/scales`, fields, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() } })

// Histórico de plantões apagados
export const apiGetDeletedDutiesHistory = (groupID, scaleID, month, year, filterType = 'duty') => httpGet({ route: `api/v1/groups/${groupID}/scales/${scaleID}/deleted-duties?month=${month}&year=${year}&filterType=${filterType}`, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserUID() } })

// --- AÇÕES EM TURNOS DA ESCALA

// Atualizar detalhes de um turno como o nome
export const apiUpdateScaleTurn = (viewerID, groupID, scaleID, turnID, fields) => httpPatch({ route: `api/turn/${viewerID}/${groupID}/${scaleID}/${turnID}`, fields, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() } })

// --- AÇÕES NO "EDITAR ESCALA"

// Nota: No futuro usar o LOG DA V2 para capturar eventos a serem desfeitos

export const apiUndoLastScaleDutiesChange = async (groupID, scaleID) => {
  const CTRL_Z_CONTENT = store.state?.app?.EditScale?.ctrl_z?.data || []

  const fullUpdate = {}

  CTRL_Z_CONTENT.forEach((reference, index) => {
    if (index === CTRL_Z_CONTENT.length - 1) {
      Object.keys(reference.data).forEach(path => {
        if (!isProtectedPath(path, groupID, scaleID)) {
          fullUpdate[path] = null
        }
      })
    }
  })

  // console.log('::: apiUndoLastScaleDutiesChange => CTRL_Z_CONTENT, fullUpdate:', JSON.stringify(CTRL_Z_CONTENT), JSON.stringify(fullUpdate))

  if (Object.keys(fullUpdate ?? []).length === 0)
  {
    return {
      httpCode: 200,
      title: "Sem alterações!",
      message: "Não existem alterações para reverter nos plantões da escala!",
    }
  }

  const response = await fbFullUpdate(fullUpdate)

  return response.code === 1 ? {
    httpCode: 200,
    title: "Feito!",
    message: "A última alteração foi revertida nos plantões da escala!"
  } : {
    httpCode: 500,
    title: "Atenção!",
    message: `Não foi possível reverter a última alteração nos plantões da escala!<br /><br /><b>Motivo</b>:<br />${JSON.stringify(response.error)}`,
  }
}
